module.exports = __webpack_public_path__ + "static/media/menu_group_prefix_list.c9cca8f0.png";